
export const contactsToEmail = (contacts) => {
  let out = '<strong>ORIGINAL CLIENT DATA</strong><br /><br /><strong>Main Contacts</strong>'
  if (contacts && contacts.mainOrig) {
    contacts.mainOrig.map(contact => {
      out += `<br />name: <strong>${contact.name}</strong><br />job_title: <strong>${contact.job_title}</strong><br />email: <strong>${contact.email}</strong><br />telephone: <strong>${contact.telephone}</strong>`
      return true
    })
  }
  out += '<br /><strong>Contact Organisers</strong>'
  if (contacts && contacts.organiserOrig) {
    contacts.organiserOrig.map(contact => {
      out += `<br />name: <strong>${contact.name}</strong><br />job_title: <strong>${contact.job_title}</strong><br />email: <strong>${contact.email}</strong><br />telephone: <strong>${contact.telephone}</strong>`
    })
  }
  out += '<br /><br /><strong>UPDATED CLIENT DATA</strong><br /><br /><strong>Main Contacts</strong>'
  if (contacts && contacts.main) {
    contacts.main.map(contact => {
      out += `<br />name: <strong>${contact.name}</strong><br />job_title: <strong>${contact.job_title}</strong><br />email: <strong>${contact.email}</strong><br />telephone: <strong>${contact.telephone}</strong>`
    })
  }
  out += '<br /><strong>Contact Organisers</strong>'
  if (contacts && contacts.organiser) {
    contacts.organiser.map(contact => {
      out += `<br />name: <strong>${contact.name}</strong><br />job_title: <strong>${contact.job_title}</strong><br />email: <strong>${contact.email}</strong><br />telephone: <strong>${contact.telephone}</strong>`
    })
  }
  out += '<br /><br /><strong>NEWLY ADDED CLIENTS</strong><br /><br /><strong>Contact Organisers</strong>'
  if (contacts && contacts.new) {
    contacts.new.map(contact => {
      out += `<br />name: <strong>${contact.name}</strong><br />job_title: <strong>${contact.job_title}</strong><br />email: <strong>${contact.email}</strong><br />telephone: <strong>${contact.telephone}</strong>`
    })
  }
  return out
}
